import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Chart from 'chart.js/auto';
import { createPortal } from 'react-dom';
import { truncateString } from '../../helper';
import { datasetColors } from '../../enum';

function LinePercentageChart(props) {
  const { labels, data, images, Tooltip, extraDatasets = [], height = 280 } = props;
  const chartRef = useRef();
  const canvasRef = useRef(null);
  const [tooltipModel, setTooltipModel] = useState();
  const dataPoint = tooltipModel?.dataPoints[0];
  const image = dataPoint && images?.[dataPoint.dataIndex];

  useEffect(() => {
    if (!canvasRef.current) return;

    chartRef.current?.destroy();
    chartRef.current = new Chart(canvasRef.current, {
      type: 'line',
      data: {
        labels: labels.map((label) => truncateString(label, 100)),
        datasets: [
          {
            data,
            label: 'Percentage',
            backgroundColor: datasetColors,
            animation: false,
            tension: 0.4,
          },
          ...extraDatasets,
        ],
      },
      options: {
        interaction: {
          mode: 'index',
          intersect: false,
        },
        responsive: true,
        maintainAspectRatio: false,
        animation: { duration: 0 },
        plugins: {
          legend: { display: false },
          tooltip: {
            mode: 'index',
            position: 'middle',
            filter: ({ datasetIndex }) => datasetIndex === 0,
            ...(Tooltip && {
              enabled: false,
              external: (context) => setTooltipModel({ ...context.tooltip }),
            }),
          },
        },
        scales: {
          x: {
            grid: { display: false },
            ticks: { padding: 10, autoSkip: false },
            stacked: true,
          },
          y: {
            beginAtZero: true,
            max: 100,
            grid: { drawTicks: false },
            border: { display: false },
            ticks: {
              padding: 14,
              autoSkip: false,
              stepSize: 25,
              count: 5,
              // eslint-disable-next-line id-denylist
              callback: (tickValue) => `${tickValue}%`,
            },
          },
        },
      },
    });
  }, [data]);

  return (
    <>
      <div style={{ height: `${height}px` }}>
        <canvas className="engage-report-question-charts__canvas" ref={canvasRef} />
      </div>
      {Tooltip
        ? createPortal(
            <Tooltip tooltipModel={tooltipModel} canvasRef={canvasRef} image={image} />,
            document.body
          )
        : null}
    </>
  );
}

LinePercentageChart.propTypes = {
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.number).isRequired,
  extraDatasets: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.shape({}))),
  images: PropTypes.arrayOf(PropTypes.string),
  Tooltip: PropTypes.func,
  height: PropTypes.number,
};

LinePercentageChart.defaultProps = {
  images: undefined,
  Tooltip: undefined,
  extraDatasets: undefined,
  height: 280,
};

export default LinePercentageChart;
